import { Component, OnInit, OnDestroy, Input, AfterViewInit } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute } from '@angular/router';
import {FileService} from '../../_services/file.service';
import { DialogPdfComponent } from '../profile/dialog-pdf/dialog.component';
import { MatDialog } from '@angular/material';

@Component({
  selector: 'app-sar-upload',
  templateUrl: './sar-upload.component.html',
  styleUrls: ['./sar-upload.component.css'],
  providers: [FileService]

})
export class SarUploadComponent implements OnInit, AfterViewInit, OnDestroy {

  profileUpload: FormGroup;
  submitdataSub: Subscription;
  formChangeSub: Subscription;
  loading = false;
  successMessage: string;
  errorFlag = false;
  submitting = false;
  error = false;
  progressValue = 0;
  incomingFile = false;
  errorMessage;
  full_path;
  orig_name;
  pdfSrc;

  constructor(
    private _fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private _fileService: FileService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.createForm();
    this.getProfileUpload();
  }

  ngOnDestroy() {
    if (this.submitdataSub) {
      this.submitdataSub.unsubscribe();
    }
    if (this.formChangeSub) {
      this.formChangeSub.unsubscribe();
    }

  }

  createForm()  {
    this.profileUpload  = this._fb.group({
      fileId: [''],
    });

  }

  ngAfterViewInit() {

    const element1 = document.querySelector('.droppable-file1');
    this.makeDroppable1(element1, this.callback1, this);

    const element2 = document.querySelector('.droppable-file2');
    this.makeDroppable2(element2, this.callback2, this);

  }

  makeDroppable1(element, callback, classObj) {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.style.display = 'none';
    input.addEventListener('change', function (e) {
      triggerCallback(e, classObj);
    });
    element.appendChild(input);
    element.addEventListener('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.add('dragover');
    });
    element.addEventListener('dragleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.remove('dragover');
    });
    element.addEventListener('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.remove('dragover');
      triggerCallback(e, classObj);
    });
    element.addEventListener('click', function() {
      input.value = null;
      input.click();
    });
    function triggerCallback(e, obj) {
      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }
      callback.call(null, files, e, obj);
    }
  }

  makeDroppable2(element, callback, classObj) {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.style.display = 'none';
    input.addEventListener('change', function (e) {
      triggerCallback(e, classObj);
    });
    element.appendChild(input);
    element.addEventListener('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.add('dragover');
    });
    element.addEventListener('dragleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.remove('dragover');
    });
    element.addEventListener('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.remove('dragover');
      triggerCallback(e, classObj);
    });
    element.addEventListener('click', function() {
      input.value = null;
      input.click();
    });
    function triggerCallback(e, obj) {
      let files;
      if (e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if (e.target) {
        files = e.target.files;
      }
      callback.call(null, files, e, obj);
    }
  }

  callback1(files, event, classobject?: any) {

    //classobject.successMessage = 'Please wait for file to upload';
    for (let i = 0; i < files.length; i++) {
      classobject.loading = true;
      let ext = '';
      // Here, we simply log the Array of files to the console.
      const mimeType = files[i].type;
      ext = files[i].name.split('.').pop();
      const allowedMIMEType = ['application/pdf'];
      if (allowedMIMEType.indexOf(mimeType) >= 0 ) {
        if ((allowedMIMEType.indexOf(mimeType) === 0) || (allowedMIMEType.indexOf(mimeType) === 1) ) {
          classobject.filetype = ext;
        } else {
          classobject.filetype = ext;
        }
        const body = {
            file: files[i],
        };
        classobject.incomingFile =true;
        classobject.progressValue = 10;
        let ii = setInterval(function(){
            classobject.progressValue++;
            if(classobject.progressValue === 65) {
                clearInterval(ii);
            }
        }, 3000);
        classobject.fileuploadSub = classobject._fileService.fileProfileUpload(body).subscribe(
          responsedata => {
            const fileId = JSON.parse(responsedata._body).data.fileId;
            classobject.profileUpload.controls['fileId'].setValue(fileId);
            classobject.filename = files[i].name;

            classobject.errorFlag = false;
            classobject.loading = false;
            classobject.progressValue = 70;
            classobject.filesubmit('fafsa');
          },
          error => {
            /* console.log(error);
            console.log(JSON.parse(error._body).message); */
            //this.submitting = false;
            /* this.errorFlag = true;
            const errordata = JSON.parse(error._body); */

            classobject.progressValue = 100;
            classobject.errorMessage = JSON.parse(error._body).message;
            classobject.errorFlag = true;
            classobject.loading = false;
          });

      } else {
        alert('File not allowed');
        classobject.loading = false;
      }
    }
  }

  callback2(files, event, classobject?: any) {
    //classobject.successMessage = 'Please wait for file to upload';
    for (let i = 0; i < files.length; i++) {
      classobject.loading = true;
      let ext = '';
      // Here, we simply log the Array of files to the console.
      const mimeType = files[i].type;
      ext = files[i].name.split('.').pop();
      const allowedMIMEType = ['application/pdf'];
      if (allowedMIMEType.indexOf(mimeType) >= 0 ) {
        if ((allowedMIMEType.indexOf(mimeType) === 0) || (allowedMIMEType.indexOf(mimeType) === 1) ) {
          classobject.filetype = ext;
        } else {
          classobject.filetype = ext;
        }
        const body = {
            file: files[i],
        };
        classobject.incomingFile =true;
        classobject.progressValue = 10;
        let ii = setInterval(function(){
            classobject.progressValue++;
            if(classobject.progressValue === 65) {
                clearInterval(ii);
            }
        }, 3000);
        classobject.fileuploadSub = classobject._fileService.fileProfileUpload(body).subscribe(
          responsedata => {
            const fileId = JSON.parse(responsedata._body).data.fileId;
            classobject.profileUpload.controls['fileId'].setValue(fileId);
            classobject.filename = files[i].name;
            //classobject.successMessage = JSON.parse(responsedata._body).message + ' Select one of the options to complete the process.';
            classobject.errorFlag = false;
            classobject.loading = false;
            classobject.progressValue = 70;
            classobject.filesubmit('calsar');
          },
          error => {
            classobject.errorFlag = true;
            classobject.loading = false;
          });

      } else {
        alert('File not allowed');
        classobject.loading = false;
      }
    }
  }

  filesubmit(type)
  {
    this.progressValue = 85;
    const fileid = this.profileUpload.controls.fileId.value;
    if (fileid !== '') {
      this.loading = true;
      const body = JSON.stringify({
        type: type,
        fileId: fileid,
      });
      this.submitting = true;
      this.submitdataSub = this._fileService.insertProfileData$(body)
      .subscribe(
        data => {
          this.error = false;
          this.submitting = false;
          const response = data;
          this.errorFlag = false;
          //this.successMessage = 'File Uploaded Successfully';
          this.loading = false;
          this.profileUpload.controls['fileId'].setValue('');
          this.progressValue = 100;
          this.router.navigate(['/profile/personal-information']);

        },
        error => {

          this.submitting = false;
          this.errorFlag = true;
          this.incomingFile = false;
          const errordata = error.hasOwnProperty('message') ? error : JSON.parse(error);
          this.errorMessage = error.hasOwnProperty('message') ? error.message:  JSON.parse(error._body).message;
          this.loading = false;
        },
      );
    } else {
      alert('Please choose file first.');
    }
  }

  sarlater() {
    this.router.navigate(['/profile/personal-information']);
  }

  getProfileUpload(){
    this._fileService.getProfileUpload$()
    .subscribe(
      data => {
        console.log(data.data);
        if(data.data){
          console.log(data);
          this.full_path = data.data.full_path;
          this.orig_name = data.data.orig_name;
        }
      },
      error => {

      }
    );
  }

  changePdf(url){

    this.pdfSrc = url;
    //console.log(this.pdfSrc);
    this.openDialog();
  }

  openDialog() {
    const dialogRef = this.dialog.open(DialogPdfComponent, {
      height: '600px',
      data: { url: this.pdfSrc }
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log(`Dialog result: ${result}`);
    });
  }

}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/sar-upload/sar-upload.component.ts